import React, { useState } from "react"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

interface Props {
  endpoint: string
  titulo: string
  filtros?: Record<string,string>
}

export default function BotaoExportar({ endpoint, titulo, filtros={} }: Props) {
  const [aberto, setAberto]   = useState(false)
  const [formato, setFormato] = useState("pdf")
  const [gerando, setGerando] = useState(false)

  const gerar = async () => {
    setGerando(true)
    try {
      const token = localStorage.getItem("moobi_token") || ""
      const params = new URLSearchParams({ formato, ...filtros })
      const url = `${API}/exportar/${endpoint}?${params}`
      const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      if (!r.ok) throw new Error("Erro")
      const blob = await r.blob()
      const ext = formato === "excel" ? "xlsx" : "pdf"
      const blobUrl = URL.createObjectURL(blob)
      if (formato === "pdf") {
        window.open(blobUrl, "_blank")
      } else {
        const a = document.createElement("a")
        a.href = blobUrl
        a.download = `moobifleet_${endpoint}_${Date.now()}.${ext}`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
      setTimeout(()=>URL.revokeObjectURL(blobUrl), 5000)
      setAberto(false)
    } catch { alert("Erro ao exportar") }
    finally { setGerando(false) }
  }

  return (
    <>
      <button className="btn btn-ghost" onClick={()=>setAberto(true)}
        style={{ fontSize:12, display:"flex", alignItems:"center", gap:6 }}>
        📊 Exportar
      </button>

      {aberto && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:2000,
          display:"flex", alignItems:"center", justifyContent:"center" }}
          onClick={e=>e.target===e.currentTarget&&setAberto(false)}>
          <div style={{ background:"#1e2f4a", borderRadius:12, padding:24, width:320,
            border:"1px solid #2d4166", boxShadow:"0 8px 32px rgba(0,0,0,0.5)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:16 }}>
              <div style={{ fontWeight:700, fontSize:15 }}>📊 Exportar {titulo}</div>
              <button onClick={()=>setAberto(false)}
                style={{ background:"none", border:"none", color:"#64748b", cursor:"pointer", fontSize:18 }}>✕</button>
            </div>

            {Object.keys(filtros).filter(k=>filtros[k]).length > 0 && (
              <div style={{ background:"#0c2a4a", border:"1px solid #2d4166", borderRadius:8, padding:"8px 12px", marginBottom:12 }}>
                <div style={{ fontSize:10, color:"#64748b", marginBottom:4 }}>Filtros ativos:</div>
                {Object.entries(filtros).filter(([,v])=>v).map(([k,v])=>(
                  <div key={k} style={{ fontSize:11, color:"#38bdf8" }}>• {k}: {v}</div>
                ))}
              </div>
            )}
            {Object.keys(filtros).filter(k=>filtros[k]).length === 0 && (
              <div style={{ fontSize:12, color:"#64748b", marginBottom:12 }}>
                Exporta todos os dados sem filtro.
              </div>
            )}

            <div style={{ marginBottom:16 }}>
              <label style={{ fontSize:11, color:"#94a3b8", display:"block", marginBottom:8 }}>Formato</label>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
                {[{id:"pdf",icone:"📄",label:"PDF",desc:"Para impressão"},
                  {id:"excel",icone:"📊",label:"Excel",desc:"Para análise"}].map(f=>(
                  <div key={f.id} onClick={()=>setFormato(f.id)}
                    style={{ padding:12, borderRadius:8, cursor:"pointer", textAlign:"center",
                      border:`2px solid ${formato===f.id?"#0ea5e9":"#2d4166"}`,
                      background:formato===f.id?"#0c2a4a":"transparent" }}>
                    <div style={{ fontSize:24, marginBottom:4 }}>{f.icone}</div>
                    <div style={{ fontSize:12, fontWeight:600, color:formato===f.id?"#38bdf8":"#f1f5f9" }}>{f.label}</div>
                    <div style={{ fontSize:10, color:"#64748b" }}>{f.desc}</div>
                  </div>
                ))}
              </div>
            </div>

            <button className="btn btn-primary" onClick={gerar} disabled={gerando}
              style={{ width:"100%", justifyContent:"center", padding:10 }}>
              {gerando ? "⏳ Gerando..." : `📥 Gerar ${formato.toUpperCase()}`}
            </button>
          </div>
        </div>
      )}
    </>
  )
}
